module.exports = __webpack_public_path__ + "img/eraser.0369c9c7.svg";